module.exports = __webpack_public_path__ + "img/7.ff4b4fc.png";